var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBookmarkOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14.9 20.8",
    style: {
      enableBackground: "new 0 0 14.9 20.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0.9,19.4l6.2-4.3c0.2-0.1,0.4-0.1,0.5,0l6.2,4.3V1.1h-13L0.9,19.4L0.9,19.4z M0.4,20.7c-0.2,0-0.4-0.2-0.4-0.5 V0.5C0,0.2,0.2,0,0.5,0h13.9c0.3,0,0.5,0.2,0.5,0.5v19.8c0,0.2-0.1,0.3-0.3,0.4s-0.3,0.1-0.5,0l-6.7-4.6l-6.7,4.6 C0.6,20.7,0.5,20.8,0.4,20.7L0.4,20.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmarkOutline);
export default __webpack_public_path__ + "static/media/icon-bookmark-outline.ecb88a86.svg";
export { ForwardRef as ReactComponent };